import { Formik, Field, Form } from "formik";
import * as Yup from "yup";

const Contact = () => {
  const initialValues = {
    username: "",
    email: "",
    message: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().required("Required"),
  });

  const onSubmit = (values) => {
    // console.log(values);
  };

  return (
    <>
      <section id="product1" className="section-p1">
        <h2 style={{ textAlign: "center", fontWeight: "bold" }}>CONTACT US</h2>

        <section id="form-details">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            <Form>
              <div>
                <label htmlFor="username">
                  <strong>Name:</strong>
                </label>
                <Field type="text" id="username" name="username" />
                {/* <ErrorMessage
                  name="username"
                  component="div"
                  className="error"
                /> */}
              </div>

              <div>
                <label htmlFor="email">
                  <strong>Email:</strong>
                </label>
                <Field type="text" id="email" name="email" />
                {/* <ErrorMessage name="email" component="div" className="error" /> */}
              </div>

              <div>
                <label htmlFor="password">
                  <strong>Message:</strong>
                </label>
                <textarea id="message" name="message" cols="30" rows="5" />
              </div>

              <button className="normal" type="submit">
                Submit
              </button>
            </Form>
          </Formik>
        </section>
      </section>

      <section id="contact-details" className="section-p1">
        <div className="details">
          <span style={{ color: "black" }}>GET IN TOUCH</span>
          <h2>Visit our locations for contact!</h2>
          <h3>Head Office</h3>
          <div>
            <h6> Hazi Abbas Ali Road 1212 Dhaka, Dhaka Division, Bangladesh</h6>

            <li>
              <i className="fa fa-phone-alt"></i>
              <h6>01329-283334</h6>
            </li>

            <li>
              <i className="fa fa-envelope"></i>
              <p>"---------------------------------------"</p>
            </li>

            <li>
              <i className="fa fa-map"></i>
              <p>"---------------------------------------"</p>
            </li>

            <li>
              <i className="fa fa-clock"></i>
              <p>"---------------------------------------"</p>
            </li>
          </div>
        </div>

        <div className="map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.6766936636527!2d90.42500817533731!3d23.79452457864037!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7af1f836141%3A0x46c3f88b61bdfe42!2sMAC!5e0!3m2!1sen!2sbd!4v1707212122267!5m2!1sen!2sbd"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="contactMap"
            width="600"
            height="450"
            style={{ border: "0" }}
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Contact;
